const actions = {
    CONTACT_ADDRESSES_READ_REQUEST: 'CONTACT_ADDRESSES_READ_REQUEST',
    CONTACT_ADDRESSES_READ_SUCCESS: 'CONTACT_ADDRESSES_READ_SUCCESS',
    CONTACT_ADDRESSES_READ_ERROR: 'CONTACT_ADDRESSES_READ_ERROR',

    readContactAddresses: contactId => ({
        type: actions.CONTACT_ADDRESSES_READ_REQUEST,
        contactId,
    }),
};
export default actions;
